export default __webpack_public_path__ + "static/media/ban.947bac9e.svg";